import React from 'react'
import { Stack } from 'react-bootstrap'
import '../SalesAdmin.css'
import customerIcon from '../../../../_metronic/images/customersIcon.svg'
import customerGreenIcon from '../../../../_metronic/images/customerGreenIcon.svg'
import SVG from 'react-inlinesvg'

interface Props {
  data: any
}

const EnrollmentCreatedCard = ({ data }: Props) => {

  return (
    <div
      className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-md-50 mb-5 mb-xl-10 bgi-no-repeat"
      style={{
       minHeight: '365px', 
        backgroundPosition: 'right top', backgroundSize: '40% auto',
      }}>
      <div className='card-title mt-5 p-3'>
        <span className='fs-3 fw-bolder text-center p-6'>Enrollment Created</span>
      </div>
      <Stack direction='horizontal' gap={4} className="mt-16 p-10">
        <SVG src={customerGreenIcon}  className='me-3'/>
        <div className='fw-bold fs-3 font-30 me-1'>{data?.newEnrollment}</div>
        <div className='fs-6 text-gray-400'>New <br />Customers <br/> <span className='fs-8'>(TPVs Passed)</span></div>
      </Stack>

      <Stack direction='horizontal' gap={4} className="mt-5 p-10 border-top">
        <SVG src={customerIcon} className='me-3 mt-1' />
        <Stack>
          <span className='fw-bolder fs-3'>{data?.totalEnrollment}</span>
          <span className='fs-8 text-gray-400'>Total Enrollments</span>
        </Stack>
      </Stack>
    </div>
  )
}

export default EnrollmentCreatedCard
